const AlertIcon = () => (
    <svg className="location-verification-alert" viewBox="0 0 24 24" aria-hidden>
        <path fill="currentColor" d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
    </svg>
);

export default AlertIcon;
